import React from "react";
import { CategoryChartQueryFn, CategoryChartQueryParam } from "../categoryChart";
import { TableKpiProvider } from "./categoryChartData.types";
import { getKpisForProvidersWithCategoryChart } from "../opendata";
import { EMPTY_ARRAY } from "../misc";
import { KpiReport } from "../processors";
import _ from "lodash";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCheck, faXmark } from "@fortawesome/pro-solid-svg-icons";
import { Column } from "react-table";

const schemeKpiLookupFn = (d: { kpiCode: string; scheme: string }) => `${d.kpiCode} %%% ${d.scheme}`;

export const getWaterSupplyTableData = (kpis: string[][], results: KpiReport[], kpiStrict: boolean = false) => {
    const schemes = _.uniq(results?.map(d => d.scheme) ?? (EMPTY_ARRAY as string[]));
    const kpiCodeToResults = _.keyBy(results, d => d.kpiCode);
    const schemeKpiCodeToResults = _.keyBy(results, d =>
        schemeKpiLookupFn({
            kpiCode: d.kpiCode,
            scheme: d.scheme
        })
    );

    const sKpis = kpiStrict
        ? kpis
        : kpis?.filter(kpi => kpi[0] != null && kpi[2] != null && kpiCodeToResults?.[kpi[0]]) ??
          (EMPTY_ARRAY as string[][]);

    const kpiNames = sKpis?.map(kpi => kpi[2]);

    const kpiStatuses = schemes?.map(scheme => {
        const nameValues =
            sKpis?.map(kpi => {
                const kpiCode = kpi[0];

                const kpiName = kpi[2];

                return {
                    name: kpiName,
                    value:
                        schemeKpiCodeToResults[
                            schemeKpiLookupFn({
                                scheme,
                                kpiCode
                            })
                        ]?.valueStatus ?? "NR"
                };
            }) ??
            (EMPTY_ARRAY as {
                name: string;
                value: string;
            }[]);

        const nameToNameValues = nameValues.reduce((prev, cur) => {
            prev[cur.name] = cur.value;
            return prev;
        }, {});

        return {
            scheme,
            ...nameToNameValues
        };

        // return [
        //     scheme,
        //     ...(sKpis?.map(kpi => {
        //         const kpiCode = kpi[0];

        //         return (
        //             schemeKpiCodeToResults[
        //                 schemeKpiLookupFn({
        //                     scheme,
        //                     kpiCode
        //                 })
        //             ]?.valueStatus ?? "NR"
        //         );
        //     }) ?? (EMPTY_ARRAY as ValueStatus[]))
        // ];
    });

    // const data = kpiStatuses?.map(d => {
    //     return {
    //         scheme
    //     };
    // });

    // console.log(kpis, results, kpiStatuses);

    const columns: Column[] = [
        {
            Header: "Water supply scheme",
            accessor: "scheme" // accessor is the "key" in the data
        },
        // ...kpiNames.map(kpiName => {
        //     return {
        //         Header: kpiName,
        //         accessor: kpiName,
        //         // defaultCanSort: false,
        //         disableSortBy: true,
        //         Cell: ({ value }) => {
        //             return (
        //                 <span>
        //                     {value === "yes" ? (
        //                         <FontAwesomeIcon icon={faCheck} className={"planning-yes"} />
        //                     ) : value === "no" ? (
        //                         <FontAwesomeIcon icon={faXmark} className={"planning-no"} />
        //                     ) : (
        //                         value
        //                     )}
        //                 </span>
        //             );
        //         }
        //     };
        // })
        {
            Header: "Plan or assessment type in place",
            // defaultCanSort: false,
            disableSortBy: true,
            columns: kpiNames.map(kpiName => {
                return {
                    Header: kpiName,
                    accessor: kpiName,
                    disableSortBy: true,
                    Cell: ({ value }) => {
                        return (
                            <span>
                                {value === "yes" ? (
                                    <FontAwesomeIcon icon={faCheck} className={"planning-yes"} />
                                ) : value === "no" ? (
                                    <FontAwesomeIcon icon={faXmark} className={"planning-no"} />
                                ) : (
                                    value
                                )}
                            </span>
                        );
                    }
                };
            })
        }
        //     // [
        //     //     {
        //     //         Header: "Column 2",
        //     //         accessor: "col2"
        //     //     },
        //     //     {
        //     //         Header: "Column 2",
        //     //         accessor: "col3"
        //     //     }
        //     // ]
        // }
        // {
        //     Header: "Column 2",
        //     accessor: "col2",
        //     Cell: ({ value }) => <span>{value}</span>
        // }
    ];

    return {
        data: kpiStatuses,
        columns,
        enabledDownload: false,
        downloadFileName: null,
        className: "supply-planning-table",
        rowClassNames: ["string", ...kpiNames.map(__ => "string-mid")]
    };
};

export const fetchWaterSupplyDemandTable: CategoryChartQueryFn = async ({
    categoryChart,
    category,
    providers,
    kpis
}: CategoryChartQueryParam): Promise<TableKpiProvider> => {
    if (!providers || providers?.length === 0 || !categoryChart || !kpis || kpis?.length === 0) return null;

    let kpiReportResults = await getKpisForProvidersWithCategoryChart(kpis, providers, false, categoryChart);

    const latestYear = _.orderBy(
        kpiReportResults?.map(d => d.year),
        d => d,
        "desc"
    )?.[0];

    if (latestYear == null) return null;

    const results = kpiReportResults?.filter(d => d.year === latestYear) ?? (EMPTY_ARRAY as KpiReport[]);

    const { data, columns, rowClassNames, downloadFileName, enabledDownload, className } = getWaterSupplyTableData(
        kpis,
        results,
        false
    );

    // console.log(results);
    // const schemes = _.uniq(results?.map(d => d.scheme) ?? (EMPTY_ARRAY as string[]));

    // const schemeKpiCodeToResults = _.keyBy(results, d =>
    //     schemeKpiLookupFn({
    //         kpiCode: d.kpiCode,
    //         scheme: d.scheme
    //     })
    // );

    // const kpiCodeToResults = _.keyBy(results, d => d.kpiCode);

    // const sKpis =
    //     kpis?.filter(kpi => kpi[0] != null && kpi[2] != null && kpiCodeToResults?.[kpi[0]]) ??
    //     (EMPTY_ARRAY as string[][]);
    // const kpiNames = sKpis?.map(kpi => kpi[2]);

    // const kpiStatuses = schemes.map(scheme => {
    //     const nameValues =
    //         sKpis?.map(kpi => {
    //             const kpiCode = kpi[0];

    //             const kpiName = kpi[2];

    //             return {
    //                 name: kpiName,
    //                 value:
    //                     schemeKpiCodeToResults[
    //                         schemeKpiLookupFn({
    //                             scheme,
    //                             kpiCode
    //                         })
    //                     ]?.valueStatus ?? "NR"
    //             };
    //         }) ??
    //         (EMPTY_ARRAY as {
    //             name: string;
    //             value: string;
    //         }[]);

    //     const nameToNameValues = nameValues.reduce((prev, cur) => {
    //         prev[cur.name] = cur.value;
    //         return prev;
    //     }, {});

    //     return {
    //         scheme,
    //         ...nameToNameValues
    //     };

    //     // return [
    //     //     scheme,
    //     //     ...(sKpis?.map(kpi => {
    //     //         const kpiCode = kpi[0];

    //     //         return (
    //     //             schemeKpiCodeToResults[
    //     //                 schemeKpiLookupFn({
    //     //                     scheme,
    //     //                     kpiCode
    //     //                 })
    //     //             ]?.valueStatus ?? "NR"
    //     //         );
    //     //     }) ?? (EMPTY_ARRAY as ValueStatus[]))
    //     // ];
    // });

    // // const data = kpiStatuses?.map(d => {
    // //     return {
    // //         scheme
    // //     };
    // // });

    // // console.log(kpis, results, kpiStatuses);

    // const columns = [
    //     {
    //         Header: "Water supply scheme",
    //         accessor: "scheme" // accessor is the "key" in the data
    //     },
    //     {
    //         Header: "Plan or assessment type in place",
    //         columns: kpiNames.map(kpiName => {
    //             return {
    //                 Header: kpiName,
    //                 accessor: kpiName
    //             };
    //         }),
    //         Cell: ({ value }) => (
    //             <span>
    //                 {value === "yes" ? (
    //                     <FontAwesomeIcon icon={faCheck} />
    //                 ) : value === "no" ? (
    //                     <FontAwesomeIcon icon={faXmark} />
    //                 ) : (
    //                     value
    //                 )}
    //             </span>
    //         )
    //         // [
    //         //     {
    //         //         Header: "Column 2",
    //         //         accessor: "col2"
    //         //     },
    //         //     {
    //         //         Header: "Column 2",
    //         //         accessor: "col3"
    //         //     }
    //         // ]
    //     }
    //     // {
    //     //     Header: "Column 2",
    //     //     accessor: "col2",
    //     //     Cell: ({ value }) => <span>{value}</span>
    //     // }
    // ];
    return {
        vis: [
            {
                categoryName: category?.name,
                type: "supply-demand",
                data: {
                    className,
                    columns,
                    data,
                    rowClassNames,
                    downloadFileName,
                    enabledDownload,
                    pageSize: data?.length
                }
            }
        ]
    };
};
